import { useState, useEffect, useRef } from "react";

export function useElapsedTimer(startTime) {
	const [elapsedSeconds, setElapsedSeconds] = useState(0);
	const startTimeRef = useRef(startTime);

	// Update start time ref when it changes
	useEffect(() => {
		startTimeRef.current = startTime;
	}, [startTime]);

	useEffect(() => {
		if (!startTimeRef.current) {
			return;
		}

		const calculateElapsed = () => {
			const now = new Date();
			const start = new Date(startTimeRef.current);
			const diffMs = now - start;
			const diffSeconds = Math.max(0, Math.floor(diffMs / 1000));
			setElapsedSeconds(diffSeconds);
		};

		// Calculate immediately
		calculateElapsed();

		// Update every second
		const timer = setInterval(calculateElapsed, 1000);

		return () => clearInterval(timer);
	}, [startTime]);

	return elapsedSeconds;
}
